import { render } from "./StorytellingView.vue?vue&type=template&id=0895d231&scoped=true&ts=true"
import script from "./StorytellingView.vue?vue&type=script&lang=ts"
export * from "./StorytellingView.vue?vue&type=script&lang=ts"

import "./StorytellingView.scss?vue&type=style&index=0&id=0895d231&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0895d231"]])

export default __exports__